export const MAX_BPM = 199;
export const MIN_BPM = 1;
export const BPM_INFINITY_HIGH = 200;
export const BPM_INFINITY_LOW = 0;
